// extracted by mini-css-extract-plugin
module.exports = {"Category":"Category_Category__mw7cl","Category_active":"Category_Category_active__2BS-J"};